import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ContactPayload {
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  school?: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class GetStartedService {
  private http: HttpClient = inject(HttpClient);

  /**
   * Submits a contact/inquiry form to the Handle team.
   * No authentication required — public endpoint.
   * @param {ContactPayload} payload - Form data from the Get Started form.
   * @returns {Observable<{ message: string }>}
   */
  sendInquiry(payload: ContactPayload): Observable<{ message: string }> {
    return this.http.post<{ message: string }>('/api/getStarted', payload);
  }
}
